
import { Component } from 'vue-property-decorator';
import { memberRoute } from '@/router/coach';
import { Member } from '@/models/member';
import GroupLevelsModal from '@/components/coach/members/GroupLevelsModal.vue';
import { mixins } from 'vue-class-component';
import { GroupScope } from '@/components/mixins/groupscope';

@Component({
  name: 'GroupsMenu',
  components: {
    GroupLevelsModal,
  },
})
export default class GroupsMenu extends mixins(GroupScope) {
  private showLevelModal = false;

  created() {
    this.getData();
  }

  async getData() {
    await this.loadGroup();
  }

  get memberRoute() {
    return { path: memberRoute };
  }

  get hasLevels() {
    return this.group.levels ? this.group.levels.length > 0 : false;
  }

  get numAlerts() {
    return this.groupMembers.reduce(
      (cnt: number, member: Member) =>
        cnt +
        (member.alerts ? member.alerts.length : 0) +
        (member.medical_conditions ? member.medical_conditions.length : 0) +
        (member.medical_notes ? 1 : 0),
      0
    );
  }

  get showAlerts() {
    return this.numAlerts > 0;
  }

  get showBadges() {
    return this.group.badges && this.group.badges.length > 0;
  }

  get showSessionPlan() {
    return this.group.scheme_slug && this.group.session_plan_uuid;
  }
}
